module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJwAAAAxCAYAAAAvOsB9AAAABGdBTUEAALGPC/xhBQAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAnKADAAQAAAABAAAAMQAAAADEqPbFAAAA+ElEQVR4Ae3SQQ0AIQADweMMYBCvSIMEEfuaGmiymTHXPp8pEBX4ox83CrwCwIGQFgAuze0MOAbSAsCluZ0Bx0BaALg0tzPgGEgLAJfmdgYcA2kB4NLczoBjIC0AXJrbGXAMpAWAS3M7A46BtABwaW5nwDGQFgAuze0MOAbSAsCluZ0Bx0BaALg0tzPgGEgLAJfmdgYcA2kB4NLczoBjIC0AXJrbGXAMpAWAS3M7A46BtABwaW5nwDGQFgAuze0MOAbSAsCluZ0Bx0BaALg0tzPgGEgLAJfmdgYcA2kB4NLczoBjIC0AXJrbGXAMpAWAS3M7A46BtMAF0bICi1EUy/sAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/矩形 2.png
// module id = Wt0L
// module chunks = 2